import { render, staticRenderFns } from "./AstrolabeView.vue?vue&type=template&id=615056fa&scoped=true"
import script from "./AstrolabeView.vue?vue&type=script&lang=js"
export * from "./AstrolabeView.vue?vue&type=script&lang=js"
import style0 from "./AstrolabeView.vue?vue&type=style&index=0&id=615056fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615056fa",
  null
  
)

export default component.exports